import * as React from "react";
import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import { FormControlLabel, Switch, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { CclPersistantDataGridMiscButton } from "../cclPersistentDataGrid/cclPersistentDataGrid";
import CclButton from "../cclButtons/cclButton";
import CclLoadingButton from "../cclButtons/cclLoadingButton";

//TODO - Resolve disparity between btn.onClick and btnClick, currently there seems to be no need for the btn.onClick prop inside of miscButtons

export interface CclDataGridToolbarProps {
    showSaveState: boolean;
    savestate: () => any;
    clearstate: () => any;
    resultBar?: boolean;
    resultBarText?: string;
    miscButtons?: CclPersistantDataGridMiscButton[];
    btnClick?: (btnId: string) => any;
    switchToggled?: (btnId: string, checked: boolean) => any;
    hideSettingsButtons?: boolean;
    anySelected: boolean;
    saveInProgress: boolean;
    clearInProgress: boolean;
}

const CclToolbarBtnSx = {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "4px",
    paddingBottom: "4px",
    margin: "5px",
    fontSize: "12px",
    lineHeight: "21px",
};

const CclToolbarBtnSxRight = {
    borderWidth: "1px",
    paddingLeft: "9px",
    paddingRight: "9px",
    paddingTop: "3px",
    paddingBottom: "3px",
    margin: "5px",
    fontSize: "12px",
    lineHeight: "21px",
    float: "right",
    color: "#307E92",
};

const CclDataGridToolbar: React.FC<CclDataGridToolbarProps> = (props) => {
    const handleMiscClick = (btnid: string) => {
        if (props.btnClick != null) props.btnClick(btnid);
    };

    const handleCheckedClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.switchToggled != null) {
            props.switchToggled(event.target.id, event.target.checked);
        } else {
            event.target.checked
                ? handleMiscClick(event.target.id + "enable")
                : handleMiscClick(event.target.id + "disable");
        }
    };

    return (
        <GridToolbarContainer>
            <Box sx={{ width: 1 }}>
                {!props.hideSettingsButtons ? (
                    <>
                        <CclLoadingButton
                            sx={CclToolbarBtnSxRight}
                            onClick={props.clearstate}
                            mode={"tertiary"}
                            loading={props.clearInProgress}
                        >
                            Clear Settings
                        </CclLoadingButton>
                        <CclLoadingButton
                            sx={CclToolbarBtnSxRight}
                            onClick={props.savestate}
                            mode={"tertiary"}
                            loading={props.saveInProgress}
                        >
                            Save Settings
                        </CclLoadingButton>
                    </>
                ) : null}
                <GridToolbarExport
                    variant="outlined"
                    sx={{
                        "&:hover": { border: "none", background: "#EAEFF4" },
                        border: "none",
                        borderRadius: "100px",
                        color: "#307E92",
                        m: "5px",
                        float: "right",
                    }}
                />
                <GridToolbarDensitySelector
                    variant="outlined"
                    sx={{
                        "&:hover": { border: "none", background: "#EAEFF4" },
                        border: "none",
                        borderRadius: "100px",
                        color: "#307E92",
                        m: "5px",
                        float: "right",
                    }}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
                <GridToolbarFilterButton
                    className="mui-filter-button"
                    sx={{
                        "&:hover": { border: "none", background: "#EAEFF4" },
                        border: "none !important",
                        borderRadius: "100px !important",
                        color: "#307E92",
                        float: "right",
                    }}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
                <GridToolbarColumnsButton
                    variant="outlined"
                    sx={{
                        "&:hover": { border: "none", background: "#EAEFF4" },
                        border: "none",
                        borderRadius: "100px",
                        color: "#307E92",
                        margin: "5px",
                        float: "right",
                    }}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                />
                {props.miscButtons &&
                    props.miscButtons.map((btn) =>
                        btn.hidden ? null : btn.type === "switch" ? (
                            <FormControlLabel
                                key={btn.id}
                                label={<Typography variant="body2">{btn.caption}</Typography>}
                                control={
                                    <Switch
                                        key={btn.id}
                                        id={btn.id}
                                        size="small"
                                        color="primary"
                                        edge="start"
                                        onChange={handleCheckedClick}
                                        checked={btn.checkedState}
                                        inputProps={{
                                            "aria-labelledby": `coach-release-toggle`,
                                        }}
                                        sx={{ ml: 4}}
                                    />
                                }
                            />
                        ) : btn.loadingBtn ? (
                            <CclLoadingButton
                                key={btn.id}
                                id={btn.id}
                                disabled={btn.enableOnSelect ? !props.anySelected : btn.disable}
                                sx={CclToolbarBtnSx}
                                size="small"
                                onClick={() => handleMiscClick(btn.id)}
                                mode={"primary"}
                                loading={btn.isLoading}
                            >
                                {btn.caption}
                            </CclLoadingButton>
                        ) : (
                            <CclButton
                                key={btn.id}
                                id={btn.id}
                                disabled={btn.enableOnSelect ? !props.anySelected : btn.disable}
                                size="small"
                                sx={CclToolbarBtnSx}
                                onClick={() => handleMiscClick(btn.id)}
                                mode={"primary"}
                            >
                                {btn.caption}
                            </CclButton>
                        )
                    )}
                {props.resultBar && <span>{props.resultBarText}</span>}
            </Box>
        </GridToolbarContainer>
    );
};

export default CclDataGridToolbar;
